module.exports = __webpack_public_path__ + "static/media/bottomLeftTopRightLine.a70b66f3.svg";